export module Messages {
  export const empty = "";
  export const defaultEmpty: string = "No se encontraron registros";
  export const closeTicketSuccess: string =
    "El cierre del ticket se realizó correctamente.";
  export const closeTicketError: string =
    "Ocurrió un error cerrando el ticket, vuelva a intentar en unos minutos.";
  export const rejectTicketError: string =
    "Ocurrió un error rechazando el ticket, vuelva a intentar en unos minutos.";
  export const closeAllTicketsSuccess: string =
    "El cierre masivo de tickets se realizó correctamente.";
  export const closeAllTicketsError: string =
    "Ocurrió un error cerrando los tickets, vuelva a intentar en unos minutos.";
  export const closeTicketConfirm = "¿Esta seguro que desea cerrar el ticket?";
  export const closeAllTicketsConfirm =
    "¿Esta seguro que desea cerrar todos ticket?";
  export const approveTicketConfirm =
    "¿Esta seguro que desea aprobar el ticket?";
  export const createTicketConfirm = "¿Esta seguro de crear el ticket?";
  export const usernamaRequired = "El usuario de acceso es requerido";
  export const passwordRequired = "La contraseña es requerida";
  export const captchaRequired = "El código captcha es requerido";
  export const rigthsReserved = "Develovers Inc. All rigths reserved.";
  export const noProductLine = "Debe seleccionar una línea de producto.";
  export const maxCountIncidents =
    "Solo se pueden agregar 5 incidencias como máximo.";
  export const genericError =
    "Ocurrió un error, por favor vuelve a intentar en unos minutos.";
  export const logoutConfirm = "¿Esta seguro que desea cerrar sesión?";
  export const workInProgress =
    "Estamos trabajando en esta funcionalidad, pronto estará disponible en la aplicación.";
  export const scheduledVisits =
    "La visita programada se ha registrado correctamente.";
  export const userActive =
    "La activación del usuario se realizó correctamente.";
  export const manageUser =
    "La cambios solicitados para el usuario se realizaron correctamente.";
  export const requestRegistredOk = "La solicitud se registró correctamente.";
  export const requestRegistredError =
    "Ocurrió un error registrando la solicitud, vuelve a intentar en unos minutos.";
  export const createRouteRegisteredOk =
    "Ruta de fabricacion se registró correctamente.";
  export const materialCodeNotExist =
    "El codigo de Material ingresado no existe";
  export const createRouteRegisteredError =
    "Ocurrió un error registrando la ruta de fabricación, vuelve a intentar en unos minutos.";
  export const creatSheetSkuRegisteredError =
    "Ocurrió un error registrando las fichas sku, vuelve a intentar en unos minutos.";
  export const requestRejectedOk = "La solicitud se rechazó correctamente.";
  export const requestRejecteddError =
    "Ocurrió un error rechazando la solicitud, vuelve a intentar en unos minutos.";
  export const deleteComponentWarning =
    "No puede eliminar un componente de esta posicion. Debe eliminar desde el ultimo al primero";
  export const deleteComponentExistOtherLevelsWarning =
    "Al eliminar esta posicion eliminara el nivel completo. Debe eliminar desde el ultimo nivel al primero";
  export const deleteComponentLastToFirstExistOtherLevelsWarning =
    "Para eliminar una posicion debe eliminar desde el ultimo al primero";
  export const getMaxCountTechnicalEspecificationsMessage = (
    maxCount: number
  ) => `Solo se pueden agregar ${maxCount} especificaciones como máximo.`;
}
